// utils/cookie.ts

export interface CookieOptions {
	path?: string
	domain?: string
	maxAge?: number // 单位：秒
	secure?: boolean
	sameSite?: 'Strict' | 'Lax' | 'None'
}
const getDomain = () => {
	let d;
	if(import.meta.env.PROD){
		if(import.meta.env.MODE === "production"){
			d = 'fs.com'
		}else if(import.meta.env.MODE === "release"){
			d = 'whgxwl.com'
		}
	}
	return d
}

const getCookie = (name: string): string | null => {
	const match = document.cookie.match(
		new RegExp(`(?:^|; )${encodeURIComponent(name)}=([^;]*)`)
	)
	return match ? decodeURIComponent(match[1]) : null
}

const setCookie = (
	name: string,
	value: string,
	options: CookieOptions = {}
): void => {
	const {
		path = '/',
		domain=getDomain(),
		maxAge,
		secure = false,
		sameSite = 'Lax',
	} = options

	let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
	cookie += `; path=${path}`
	if (domain) cookie += `; domain=${domain}`
	if (maxAge) cookie += `; max-age=${maxAge}`
	if (secure) cookie += `; secure`
	if (sameSite) cookie += `; samesite=${sameSite}`

	document.cookie = cookie
}

const deleteCookie = (name: string, path = '/'): void => {
	let domain = getDomain();
	console.log("delete_cookie")
	console.log(domain)
	let cookie = `${encodeURIComponent(name)}=; path=${path}; max-age=0`
	if (domain){
		cookie += `; domain=${domain}`
	}
	document.cookie = cookie
}

export const Cookie = {
	get: getCookie,
	set: setCookie,
	delete: deleteCookie,
}